import { all, call, put, takeLatest } from "redux-saga/effects";
import { GET_LIST_CHITIETCUAHANG } from "actions/ChiTietCuaHang/actionTypes";
import {
  getListChiTietCuaHangSuccess,
  getListChiTietCuaHangFailure,
} from "actions/ChiTietCuaHang";
import ChiTietCuaHangApi from "service/danhSachKhachHangApi";
import { pushNotification } from "utils/notifications";

function* getListChiTietCuaHang(action) {
  try {
    const response = yield call(ChiTietCuaHangApi.list, action.dataSearch);
    if (response.ok) {
      yield put(getListChiTietCuaHangSuccess(response.data));
    } else {
      pushNotification("Lỗi xảy ra", "error", "TOP_CENTER", 1000);
      yield put(getListChiTietCuaHangFailure());
    }
  } catch (error) {
    pushNotification("Lỗi xảy ra", "error", "TOP_CENTER", 1000);
    yield put(getListChiTietCuaHangFailure());
  }
}

function* watchGetRequest() {
  yield takeLatest(GET_LIST_CHITIETCUAHANG, getListChiTietCuaHang);
}

export default function* sagas() {
  yield all([watchGetRequest()]);
}
